import { buildBookletSpreads } from '@/content/printMenu/buildBookletSpreads'
import type { MenuPage } from '@/content/printMenu/types'
import { cn } from '@/lib/utils'
import { renderMenuPage } from '@/components/printMenu/renderMenuPage'

type MenuBookletScrollProps = {
  pages: MenuPage[]
  totalPages: number
  className?: string
}

/** Scrollable spread preview — used for reduced motion and as a print fallback layout. */
export function MenuBookletScroll({ pages, totalPages, className }: MenuBookletScrollProps) {
  const spreads = buildBookletSpreads(pages)

  return (
    <div className={cn('print-menu-booklet', className)}>
      {spreads.map((spread, spreadIndex) => {
        const spreadKey =
          spread.type === 'solo'
            ? `solo-${spread.startPageNumber}`
            : `spread-${spread.startPageNumber}`

        return (
          <div
            key={spreadKey}
            className={cn(
              'print-menu-spread',
              spread.type === 'solo' && 'print-menu-spread--solo',
              spread.type === 'spread' && spread.padRight && 'print-menu-spread--pad-right',
            )}
            data-spread-index={spreadIndex}
          >
            {spread.pages.map((page, leafIndex) => {
              const pageNumber = spread.startPageNumber + leafIndex
              return (
                <div
                  key={page.kind === 'blank' ? `blank-${pageNumber}` : `${page.kind}-${pageNumber}`}
                  className="print-menu-spread__leaf"
                  data-page-number={pageNumber}
                >
                  {renderMenuPage(page, pageNumber, totalPages)}
                </div>
              )
            })}
          </div>
        )
      })}
    </div>
  )
}
